<template>
  <ElDialog
    class="sample-biomaterial-modal"
    :title="$t('Laboratory.SamplingBiomaterial')"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)">
    <ElCard shadow="never">
      <ElFormItem
        class="sample-biomaterial-modal__biomaterial"
        :label="$t('Laboratory.Biomaterial.Biomaterial')">
        <span class="sample-biomaterial-modal__biomaterial-name">
          {{ biomaterial.biomaterial_type_translate || biomaterial.biomaterial_type }}
        </span>
      </ElFormItem>

      <ElFormItem :label="$t('Base.Code')">
        <svg class="sample-biomaterial-modal__bar-code" ref="barCode"></svg>
      </ElFormItem>
    </ElCard>

    <template #footer>
      <ElButton type="primary" @click="print"> {{ $t('Base.Print') }}</ElButton>

      <ElButton
        v-if="status === Biomaterial.enum.statuses.NotAssembled"
        type="primary"
        plain
        :loading="loading"
        @click="completeSampling">
        {{ $t('Laboratory.CompleteSampling') }}
      </ElButton>
    </template>

    <BiomaterialBarCodePrinterDocument
      :biomaterial="biomaterial"
      :patient="patient"
      ref="printerDocument" />
  </ElDialog>
</template>

<script>
import axios from 'axios';
import JsBarcode from 'jsbarcode';

import { Biomaterial } from '@/models/laboratory/Biomaterial.model';
import { User } from '@/models/User.model';
import { Patient } from '@/models/Patient.model';
import { GlobalModalInstance } from '~widgets/GlobalModalAndDrawer';
import BiomaterialBarCodePrinterDocument from '@/components/laboratory/BiomaterialBarCodePrinterDocument/index.vue';
import { amplitudeService } from '~shared/lib';

export default {
  name: 'SampleBiomaterialModal',
  components: { BiomaterialBarCodePrinterDocument },
  emits: ['update:modelValue', 'action'],
  props: {
    modelValue: Boolean,
    biomaterial: [Biomaterial, Object],
    patient: [User, Patient, Object],
    status: String, // Study status
    orderId: Number,
  },
  data() {
    return {
      loading: false,
    };
  },

  watch: {
    biomaterial: {
      handler(value) {
        setTimeout(() =>
          JsBarcode(this.$refs.barCode, value.id, {
            height: '26px',
            displayValue: false,
          })
        );
      },
      immediate: true,
    },
  },

  methods: {
    print() {
      this.$refs.printerDocument?.print();
      this.sendAmplitudePrintBarcode(this.biomaterial.id, this.patient.id, this.orderId);
    },

    async completeSampling() {
      this.loading = true;

      try {
        const { data } = await Biomaterial.updateStatusByBiomaterialId({
          id: this.biomaterial.id,
          status: Biomaterial.enum.statuses.Assembled,
        });

        this.$notify({ type: 'success', title: this.$t('Notifications.SuccessUpdated') });
        this.$emit(
          'action',
          new GlobalModalInstance({
            name: 'updated',
            data: { biomaterial: data.data },
          })
        );
      } catch (err) {
        this.$notify({
          type: 'error',
          title: axios.isAxiosError(err) ? err.message : String(err),
        });
      }

      this.loading = false;
    },

    sendAmplitudePrintBarcode(biomaterialId, orderId, patientId) {
      amplitudeService.logEvent('laboratory_order.print_barcode', {
        biomaterial_id: biomaterialId,
        order_id: orderId,
        patient_id: patientId,
      });
    },
  },

  setup: () => ({ Biomaterial }),
};
</script>

<style lang="scss" src="./index.scss" />
<i18n src="@/locales/base.locales.json" />
<i18n src="@/locales/notifications.locales.json" />
<i18n src="@/locales/laboratory.locales.json" />
